import coafinaWinners from '../../Module/Assets/coafinaWinners.jpg';
import './style.css';

import {MIDDLE_SECTION} from '../../Module/General';

function LogoSectionAbout() {
  return (
    <div className="LogoSectionAbout">
      <h1>{MIDDLE_SECTION.TITLE}</h1>
      <p>{MIDDLE_SECTION.LONG_DESCRIPTION}</p>
    </div>
  );
}

function Logo() {
  return (
    <div className="logoS">
      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/CkS11BsvaBs?si=nktqpOMXwGmmm4PK"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    </div>
  );
}

function Anuncios() {
  return (
    <div className="AnuncioS">
      <img className="Anuncio" src={coafinaWinners} alt="Winners" />
    </div>
  );
}

function CdCSectionAbout() {
  return (
    <div className="CdCSectionAbout">
      <h1>Código de Conducta</h1>
      <p>
        {MIDDLE_SECTION.CDC_SHORT}{' '}
        <a href={MIDDLE_SECTION.CDC_URL}>{MIDDLE_SECTION.CDC_URL}</a>
      </p>
    </div>
  );
}

export {Anuncios, CdCSectionAbout, Logo, LogoSectionAbout};
